// Loại workspace ghi trong marker `.claude/avatar.json` (field `kind`) — card #254.
//
// Vì sao cần: extension "Avatar DataHub" dựng workspace phân tích dữ liệu (~/AvatarDataHub)
// có CLAUDE.md riêng + `.claude/avatar.json` (để `avatar ai *` nhận workspace). Marker đó làm
// `status`/`doctor` đăng ký thư mục vào registry ⇒ `avatar update` → `sync --all` → `avatar sync`
// thay CLAUDE.md, cài symlink farm + hook pack + tự bật tool dev. Workspace dạng đó khai
// `"kind": "datahub"`; CLI coi mọi `kind` ≠ "dev" là NGOÀI phạm vi `sync`/registry.
//
// Fail-safe: thiếu file / JSON hỏng / không phải object / `kind` không phải chuỗi khác rỗng
// ⇒ "dev" — đúng hành vi trước khi có field này (workspace dev cũ không ghi `kind`).
import { readFileSync } from "node:fs";
import { join } from "node:path";
import { WORKSPACE_MARKER_RELATIVE } from "./workspace-marker-constants.js";

export const DEV_WORKSPACE_KIND = "dev";

export function readWorkspaceMarkerKind(workspaceRoot: string): string {
  try {
    const parsed: unknown = JSON.parse(
      readFileSync(join(workspaceRoot, WORKSPACE_MARKER_RELATIVE), "utf8"),
    );
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return DEV_WORKSPACE_KIND;
    }
    const kind = (parsed as Record<string, unknown>).kind;
    if (typeof kind !== "string" || kind.trim() === "") return DEV_WORKSPACE_KIND;
    return kind.trim();
  } catch {
    return DEV_WORKSPACE_KIND;
  }
}

/** `true` khi workspace KHÔNG phải loại dev ⇒ `sync` + registry phải đứng ngoài. */
export function isNonDevWorkspace(workspaceRoot: string): boolean {
  return readWorkspaceMarkerKind(workspaceRoot) !== DEV_WORKSPACE_KIND;
}
